export const CREATE='CREATE';
export const FETCH_ALL='FETCH_ALL';
export const UPDATE='UPDATE';
export const DELETE='DELETE';
export const LIKE='LIKE';

export const LOGIN='LOGIN';
export const USER_LOADING='USER_LOADING';
export const USER_LOADED='USER_LOADED';
export const AUTH_ERROR="AUTH_ERROR";
export const LOGIN_SUCCESS='LOGIN_SUCCESS';
export const LOGIN_FAIL='LOGIN_FAIL';
export const LOGOUT_SUCCESS='LOGOUT_SUCCESS';
export const REGISTER_SUCCESS='REGISTER_SUCCESS';
export const REGISTER_FAIL='REGISTER_FAIL';
export const GET_ERRORS='GET_ERRORS';
export const CLEAR_ERRORS='CLEAR_ERRORS';
export const GET_USER="GET_USER";

export const GET_SHOP_DATA="GET_SHOP_DATA";


